export const InsStatusCheckTypeEnums = {
  OK: 'ins_check_ok',
  KO: 'ins_check_ko',
  "00": '00',
  "01": '01',
  "02": '02',
}
